import Slider from "../components/Slider";
import Products from "./Products";

const Home = () => {
  return (
    <div>
      <Slider />
      <Products />
    </div>
  );
};

export default Home;
